import { render, staticRenderFns } from "./DashTable.vue?vue&type=template&id=fee588ba&"
import script from "./DashTable.vue?vue&type=script&lang=js&"
export * from "./DashTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports